import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  const link =
    "text-[13px] tracking-[0.06em] uppercase font-semibold text-[#1A1918] hover:text-[#C86641] transition-colors";

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#FAFAFA]/85 border-b border-[#E5E3DD]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display font-extrabold text-[#1A1918] text-sm md:text-base tracking-tighter leading-[0.95]"
          onClick={close}
        >
          E-PRO<span className="text-[#C86641]">.</span><br />
          Intervention
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={link} data-testid="nav-home">Accueil</NavLink>
          <NavLink to="/#services" className={link} data-testid="nav-services">Services</NavLink>
          <NavLink to="/#realisations" className={link} data-testid="nav-realisations">Réalisations</NavLink>
          <NavLink to="/#avis" className={link} data-testid="nav-avis">Avis</NavLink>
          <NavLink to="/devis" className={link} data-testid="nav-devis">Devis</NavLink>
          <NavLink to="/#contact" className={link} data-testid="nav-contact">Contact</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          {user && user.role ? (
            <>
              {user.role === "admin" ? (
                <Link to="/admin" className={link} data-testid="nav-admin-dashboard">Tableau de bord</Link>
              ) : (
                <Link to="/espace-client" className={link} data-testid="nav-client-dashboard">Mon espace</Link>
              )}
              <button
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-[13px] tracking-[0.06em] uppercase font-semibold text-[#5C5A56] hover:text-[#1A1918] transition-colors"
                data-testid="nav-logout-button"
              >
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/connexion" className={link} data-testid="nav-login-link">Connexion</Link>
              <Link
                to="/devis"
                data-testid="nav-cta-devis"
                className="bg-[#1A1918] text-[#FAFAFA] px-5 py-2.5 text-[13px] tracking-[0.06em] uppercase font-semibold hover:bg-[#C86641] transition-colors"
              >
                Demander un devis
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E3DD] bg-[#FAFAFA]">
          <nav className="px-6 py-6 flex flex-col gap-5">
            <Link to="/" className={link} onClick={close} data-testid="nav-mobile-home">Accueil</Link>
            <a href="/#services" className={link} onClick={close} data-testid="nav-mobile-services">Services</a>
            <a href="/#realisations" className={link} onClick={close} data-testid="nav-mobile-realisations">Réalisations</a>
            <a href="/#avis" className={link} onClick={close} data-testid="nav-mobile-avis">Avis</a>
            <Link to="/devis" className={link} onClick={close} data-testid="nav-mobile-devis">Devis</Link>
            <a href="/#contact" className={link} onClick={close} data-testid="nav-mobile-contact">Contact</a>
            <div className="h-px bg-[#E5E3DD] my-2" />
            {user && user.role ? (
              <>
                <Link
                  to={user.role === "admin" ? "/admin" : "/espace-client"}
                  className={link}
                  onClick={close}
                  data-testid="nav-mobile-dashboard"
                >
                  {user.role === "admin" ? "Tableau de bord" : "Mon espace"}
                </Link>
                <button
                  onClick={async () => { close(); await logout(); navigate("/"); }}
                  className="text-left text-[13px] tracking-[0.06em] uppercase font-semibold text-[#5C5A56]"
                  data-testid="nav-mobile-logout"
                >
                  Déconnexion
                </button>
              </>
            ) : (
              <>
                <Link to="/connexion" className={link} onClick={close} data-testid="nav-mobile-login">Connexion</Link>
                <Link
                  to="/devis"
                  onClick={close}
                  data-testid="nav-mobile-cta-devis"
                  className="bg-[#1A1918] text-[#FAFAFA] px-5 py-3 text-[13px] tracking-[0.06em] uppercase font-semibold text-center"
                >
                  Demander un devis
                </Link>
              </>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
